/**
 * Deletes cookie
 * @param {String} name - cookie's name
 */
export default function deleteCookie(name) {
	document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
}
